module.exports = __webpack_public_path__ + "static/media/physical_rsvp.a74d915f.svg";